import { render, staticRenderFns } from "./ReleaseWidget.vue?vue&type=template&id=11aa33a1&scoped=true&"
import script from "./ReleaseWidget.vue?vue&type=script&lang=js&"
export * from "./ReleaseWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseWidget.vue?vue&type=style&index=0&id=11aa33a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aa33a1",
  null
  
)

export default component.exports